import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';


import { MappingTree } from '@classes/mapping/mapping-tree';

@Component({
    selector: 'app-selection-category',
    templateUrl: './selection-category.component.html',
    styleUrls: ['./selection-category.component.scss']
})
export class SelectionCategoryComponent implements OnChanges, OnDestroy {
    @Input() categories: MappingTree[] = [];
    @Input() depsLabel: string;
    @Input() isRoot: boolean;
    @Input() selection: any[];
    @Output() itemSelected = new EventEmitter<any>();
    @Output() categorySelected = new EventEmitter<any>();

    private unsubscribeAll = new Subject<void>();

    constructor(
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.selection?.currentValue !== changes.selection?.previousValue) {
            this.initCategories();
        }
    }

    ngOnDestroy(): void {
        this.unsubscribeAll.next();
        this.unsubscribeAll.complete();
    }

    onToggleItem(item: MappingTree): void {
        item.isOpen = !item.isOpen;
    }

    onCategorySelected(category: any, selectItems = false): void {
        if (selectItems) {
            if (category.dependencies?.length) {
                category.isSelected = category.isSelected ? false : true;
                category.someSelected = false;
            }
        }
        this.categorySelected.emit(category);
    }

    onItemSelected(item: any, category?: any): void {
        if (category) {
            category.isSelected = category.dependencies.every(d => this.selection.find(s => s.id === d.id));
            category.someSelected = category.dependencies.some(d => this.selection.find(s => s.id === d.id)) && !category.isSelected;
        }
        this.itemSelected.emit(item);
    }

    private initCategories(): void {
        this.categories = this.categories
            .map(c => {
                if (c.dependencies?.length) {
                    c.isSelected = c.dependencies.every(d => this.selection.find(s => s.id === d.id));
                    c.someSelected = c.dependencies.some(d => this.selection.find(s => s.id === d.id)) && !c.isSelected;
                }
                return c;
            })
            .sort((a, b) => a.displayOrder > b.displayOrder ? 1 : -1);
    }

}
